import { render, staticRenderFns } from "./SelectMimicry.vue?vue&type=template&id=710dbee2&"
import script from "./SelectMimicry.vue?vue&type=script&lang=js&"
export * from "./SelectMimicry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports